<template>
    <div>
        {{previousYears}}
        <ul>
            <li v-for="(year, i) in previousYears">
                {{year}}
            </li>
        </ul>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "PreviousYears",
    computed: {
        ...mapState({
            previousYears : state.adoption.adoptionData
        })
    }
}
</script>

<style scoped>

</style>